import {CreateRecordAuditRequestBody} from '@dms/api/core';
import {RecordIdHttpModel} from '@dms/api/shared';
import {RecordAuditMetadataFormValue, toRecordAuditHeaderFields} from '@dms/shared';

export const toCreateRecordAuditBody = (args: {
  values: RecordAuditMetadataFormValue;
  recordAuditDefinitionId: string;
  pairedRecord: RecordIdHttpModel | null;
}): CreateRecordAuditRequestBody => ({
  recordAuditDefinitionId: args.recordAuditDefinitionId,
  ...toRecordAuditHeaderFields(args.values, args.pairedRecord),
});
